const MOI_VENDOR_TYPES = {
  STAP: 'Staff Appraiser',
  DRVI: 'Drive In',
  DRP: 'Repair Facility',
  IA: 'Independent Appraiser',
  NDRP: 'Open Shop Repair Facility',
} as const;

export default MOI_VENDOR_TYPES;
